module.exports = __webpack_public_path__ + "static/media/27OCHA5.76d44259.jpg";